export const base64Prefix = 'data:application/pdf;base64,';

type NavigatorWithMsSave = Navigator & {
    msSaveOrOpenBlob: (blob: Blob, defaultName?: string) => boolean;
};

export const downloadBase64PdfInIE = (pdf: string) => {
    if (!('msSaveOrOpenBlob' in window.navigator)) {
        return;
    }
    const byteCharacters = atob(pdf.replace(base64Prefix, ''));
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], {
        type: 'application/pdf',
    });
    (window.navigator as NavigatorWithMsSave).msSaveOrOpenBlob(blob, 'download.pdf');
};
